import axios from 'axios'

const ApiLocation = process.env.REACT_APP_API_HOST
axios.defaults.headers.common['Content-Type'] = 'application/json'

export const fetchBannerProducts = (centerId, lang) => {
    return axios.get(`${ApiLocation}/natural-stone/${centerId}/banner-products/${lang}`)
}

export const fetchPerfectSlabs = (centerId, family) => {
    return axios.get(`${ApiLocation}/natural-stone/${centerId}/perfect-slabs/${family}`)
}

export const fetchNewest = (centerId) => {
    return axios.get(`${ApiLocation}/natural-stone/${centerId}/newest`)
}

export const fetchOutlet = (centerId) => {
    return axios.get(`${ApiLocation}/natural-stone/${centerId}/outlet`)
}